import { autoserialize, autoserializeAs } from 'cerialize';

export class Batch {
  @autoserialize id!: string;
  @autoserializeAs('date_acquired') dateAcquired!: number;
  @autoserializeAs('date_created') dateCreated!: number;
}
